// import testData from "../../api/testData";

const state = () => ({
    message: []
})

const getters = {
    getMessageInfo(state) {
        return state.message;
    }
}

const mutations = {
    ALERT_MESSAGE(state, {type , text, timeout}) {
        state.message.push({type, text, timeout});
        if (timeout !== null) {
            setTimeout(() => {
                state.message.pop();
            }, timeout);
        } else {
            setTimeout( () => {
                state.message.pop();
            }, 3000)
        }
    }
}

const actions = {
    printAlert ({commit} , payload) {
        commit('ALERT_MESSAGE', payload);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

